<template>
    <div class="mb-2">
        <input type="button" @click="adicionarEstilo" class="btn btn-success" value="Criar">
    </div>
</template>
<script>

export default {

    data: function () {
        return {
            VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
            loading: false,
            ProgressoInt: {
                id_vsl: 178,
                bar_hight: 10,
                bar_cor: "#de1717",
               
            },
            errorMessage: null,

        }
    },

    methods: {
        adicionarEstilo() {
            fetch(`http://${this.VUE_APP_HOST_API_BACKEND}/bar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: '{"id_vsl":"' + this.ProgressoInt.id_vsl +
                    '","bar_cor":"' + this.ProgressoInt.bar_cor +
                    '","bar_hight":"' + this.ProgressoInt.bar_hight +
                    '"}'
            })

                .then(response => {
            
                    
                    return this.$router.push('');

                })
                .catch(err => console.error(err));
        },

    }
}


</script>
